// import { FaCheckCircle } from 'react-icons/fa';
import img1 from '../../Assets/aboutClg.png';
import './HomePageCss/AboutSection.css';
import AnimatedText from '../../AnimatedText';
import icons from '../../Assets/HomeIcon.png'
const AboutSection = () => {
    return (
        <>
            {/* <section className="about-section"> */}
            <div className="about-container">
                <div className="about-left">
                    <div className="main-img">
                        <img src={img1} alt="Doctor and Patient" className="image-bg" />
                        <div className="experience-badge">
                            <svg viewBox="0 0 200 200" className="circular-text">
                                <defs>
                                    <path
                                        id="topTextPath"
                                        d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
                                    />
                                </defs>

                                {/* Rotating outer text only */}
                                <g className="rotating-text">
                                    <text fontSize="22" fill="#333" fontWeight="500">
                                        <textPath
                                            href="#topTextPath"
                                            startOffset="50%"
                                            textAnchor="middle"
                                            side="left"
                                        >
                                            years of experience years of experience
                                        </textPath>
                                    </text>
                                </g>

                                {/* Static center number */}
                                <text x="100" y="110" textAnchor="middle" fontSize="40" fontWeight="bold" fill="black">
                                    15+
                                </text>
                            </svg>
                        </div>


                    </div>
                </div>

                <div className="about-right">
                    <span className="rb-headingTag">About US</span>
                    <AnimatedText tag="h2" type="words" y={30} className="title">
                        Explore Tests by Organ<br /> for Smarter Health Screening
                    </AnimatedText>


                    <p className="description">At RB Diagnostic, we offer an extensive range of tests covering all major health parameters. From routine screenings to advanced diagnostics, our tests are designed to deliver accurate results with the highest precision—empowering you and your doctor to make informed health decisions at every step.</p>

                    {/* <AnimatedText tag="p" type="words" y={-20} className="description">
                        At RB Diagnostic, we offer an extensive range of tests covering all major health parameters. From routine screenings to advanced diagnostics, our tests are designed to deliver accurate results with the highest precision—empowering you and your doctor to make informed health decisions at every step.
                    </AnimatedText> */}


                    <div className="about-right-buttom">
                        <ul className="features">
                            <li>
                                <h3>
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3TFrFjsmYZU9MweAiXpAPSNPmmW4GsHaO_w&s" alt="Lab" className="feature-icon" />
                                    NABL Accredited Labs
                                </h3>
                                <p>Ensuring the highest standards in testing accuracy and reliability across all diagnostic services.</p>
                            </li>
                            <li>
                                <h3>
                                    <img src={icons} alt="Home Collection" className="feature-icon" />
                                    Home Collection
                                </h3>
                                <p>Enjoy hassle-free sample collection services from the comfort of your home.</p>
                            </li>
                            <li>
                                <h3>
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSweA0NXf0eK_SuCwSxr0R5zbGI9bj7T5azVw&s" alt="Fast Reports" className="feature-icon" />
                                    Fast Reports
                                </h3>
                                <p>Receive accurate and timely diagnostic reports to support quicker decisions.</p>
                            </li>
                        </ul>

                        {/* <button className="read-more-btn rbdButton"><span className='btn-text'>Read More</span></button> */}
                    </div>
                </div>

            </div>
            {/* </section> */}
        </>
    )
}

export default AboutSection;